// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__WvVKL","dragIcon":"Choice_dragIcon__2jIIo","left":"Choice_left__3xV18","input":"Choice_input__1a34v"};